import { useParams } from 'react-router-dom';

import useGetOrganisation from '../../../api/queries/useGetOrganisation';
import PageWrapper from '../../../components/molecules/PageWrappers/PageWrapper';
import UsersTable from '../Users/components/UsersTable';

export const OrganisationUsers = () => {
  const { orgId } = useParams<{ orgId: string }>();

  const { data: organisation } = useGetOrganisation(orgId ?? '');

  return (
    <PageWrapper className="bg-gray-50">
      <div className="flex w-full flex-col items-start justify-start px-4 md:px-6 lg:px-8">
        <div className="mb-8 flex w-full flex-col gap-6">
          <div className="w-full rounded-xl bg-white p-6 shadow-sm">
            <div className="flex flex-col gap-6">
              <div className="flex flex-col">
                <h1 className="text-xl font-semibold text-gray-800">{organisation?.name} Users</h1>
                <p className="text-sm text-gray-600">Manage roles for this organisation's users</p>
              </div>
            </div>
          </div>

          <UsersTable
            orgId={orgId ?? ''}
            showViewMatters={false}
            isGlobalAdminUserTable={true}
            onViewUserMatters={() => null}
          />
        </div>
      </div>
    </PageWrapper>
  );
};
